/**
 * Збій → вигляд сторінки помилки (UX-50). Лінивий чанк разом зі сторінками помилок
 * (`ErrorState.tsx`): головному чанку потрібні лише коди й `traceId` (`classify.ts`).
 */
import { shaped } from './classify.ts';

export type FailureKind = 'forbidden' | 'not_found' | 'maintenance' | 'offline' | 'server';

/**
 * Збій → вигляд сторінки. Оновлення (UX-50, UX-19) — `503` з кодом `maintenance` або без коду
 * застосунку (так відповідає edge, поки api перезапускається). Перевантаження БД (`503
 * write_unavailable`, `schema_unavailable`…) — не оновлення, а звичайна тимчасова відмова.
 * `502`/`504` — звичайний збій сервера: «Спробувати ще раз», бо оновленням вони не обов'язково є.
 */
export function failureKind(error: unknown): FailureKind {
  const { status, code } = shaped(error);
  if (status === 0) return 'offline';
  if (status === 403) return 'forbidden';
  if (status === 404) return 'not_found';
  if (status === 503 && (code === 'maintenance' || code === 'http_503' || code === 'API-503')) {
    return 'maintenance';
  }
  return 'server';
}

/**
 * Скільки секунд сервер просить чекати (`Retry-After`) — для «очікуваного часу» оновлення.
 * Лише додатне число; хибне — `null`.
 */
export function expectedWaitSeconds(error: unknown): number | null {
  const { retryAfter } = shaped(error);
  return typeof retryAfter === 'number' && Number.isFinite(retryAfter) && retryAfter > 0
    ? Math.ceil(retryAfter)
    : null;
}
